// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"setting-input_inputContainer___yoMZ","label":"setting-input_label__VniDR","input":"setting-input_input__2XK_k"};